import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function ChainsawChain({ idVariant = '', className }: Props) {
  return (
    <IconBase name="chainsaw-chain" w={24} className={className}>
      <g clipPath={`url(#chainsawchain_${idVariant}_clip0_10180_12245)`}>
        <path
          d="M12.0823 2.76615C12.9415 1.90695 14.0048 1.37178 15.1179 1.15859L15.1186 1.15789C17.0013 0.798524 19.0358 1.35875 20.504 2.82692C21.9721 4.29499 22.5337 6.32935 22.173 8.21377C21.96 9.32729 21.425 10.3912 20.5655 11.2507C19.8703 11.9459 19.0388 12.4298 18.1541 12.7009L18.13 12.7085L18.1058 12.7147C16.849 13.0309 15.6343 13.7043 14.6704 14.6682C13.7065 15.6321 13.0644 16.7943 12.7404 18.029L12.7348 18.0511C12.4701 18.9744 11.9749 19.8426 11.2523 20.5654C9.75899 22.0586 7.66111 22.5684 5.7411 22.1239V22.1225C4.67496 21.8761 3.659 21.3358 2.82774 20.5046C1.9964 19.6731 1.45538 18.6569 1.20912 17.5905C0.765117 15.671 1.27473 13.5737 2.76697 12.0815C3.42145 11.427 4.1956 10.9614 5.02156 10.6817L5.04918 10.6541L5.31021 10.5851C6.54261 10.2608 7.70248 9.62081 8.66275 8.66055C9.62286 7.70034 10.2624 6.54098 10.5866 5.30869L10.6556 5.04767L10.6833 5.02005C10.9624 4.19445 11.4281 3.42039 12.0823 2.76615Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M8.52242 17.8374C9.3438 17.016 9.33206 15.6725 8.49618 14.8367C7.66031 14.0008 6.31684 13.989 5.49546 14.8104C4.67408 15.6318 4.68583 16.9753 5.5217 17.8111C6.35757 18.647 7.70104 18.6588 8.52242 17.8374Z"
          fill="currentColor"
        />
        <path
          d="M17.8789 8.48097C18.7002 7.65959 18.6885 6.31612 17.8526 5.48025C17.0167 4.64438 15.6733 4.63263 14.8519 5.45401C14.0305 6.27539 14.0423 7.61886 14.8781 8.45473C15.714 9.29061 17.0575 9.30235 17.8789 8.48097Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={`chainsawchain_${idVariant}_clip0_10180_12245`}>
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </IconBase>
  )
}

export default ChainsawChain
